import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
const TermsOfService = () => {
  return <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow container mx-auto px-6 py-32 max-w-7xl">
        <h1 className="text-[2.5rem] md:text-[2.75rem] font-charter font-medium text-primary mb-8">
          Terms of Service
        </h1>
        <div className="prose prose-lg prose-stone max-w-none">
          <p className="text-secondary italic mb-8">Effective Date: February 11, 2025</p>
          
          <h2 className="text-xl font-semibold mt-8 mb-4">1. Agreement to Terms</h2>
          <p className="text-secondary">
            By accessing and using planniFi's services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">2. Subscription & Payment</h2>
          <ul className="list-disc pl-6 text-secondary">
            <li>Users are charged a monthly subscription fee of $247 or an annual subscription of $2,388 billed yearly ($199/month).</li>
            <li>Payments are processed automatically each billing cycle.</li>
            <li>Users may cancel at any time, with access remaining until the end of the paid period.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">3. Account Use</h2>
          <ul className="list-disc pl-6 text-secondary">
            <li>Each account is limited to one user. Agencies must create separate accounts for different clients.</li>
            <li>Users are responsible for maintaining account security.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">4. API Integration & Data Usage</h2>
          <ul className="list-disc pl-6 text-secondary">
            <li>The platform syncs user data via API connections with Shopify, Meta, Google, and TikTok.</li>
            <li>We do not modify or influence ad spend decisions.</li>
            <li>Users must ensure correct API connections and permissions.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">5. Data Export</h2>
          <p className="text-secondary">
            Users may export their data in CSV format but are responsible for securing their exported data.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">6. Limitation of Liability</h2>
          <ul className="list-disc pl-6 text-secondary">
            <li>We do not guarantee the accuracy of performance predictions.</li>
            <li>We are not responsible for losses incurred from advertising decisions.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">7. Service Availability</h2>
          <ul className="list-disc pl-6 text-secondary">
            <li>We strive for uptime but do not guarantee uninterrupted service.</li>
            <li>We may suspend services for maintenance or updates.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">8. Termination</h2>
          <p className="text-secondary">
            We reserve the right to suspend or terminate accounts that violate these Terms.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">9. Changes to Terms</h2>
          <p className="text-secondary">
            We may update these Terms, and users will be notified of significant changes.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">10. Contact Information</h2>
          <p className="text-secondary">
            If you have any questions about these Terms, please contact us at{" "}
            <a href="mailto:contact@plannifi.com" className="text-primary hover:underline">
              contact@plannifi.com
            </a>
            .
          </p>
        </div>
      </main>
      <Footer />
    </div>;
};
export default TermsOfService;